import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-registerredirecter',
  templateUrl: './auth-registerredirecter.component.html',
  styleUrls: ['./auth-registerredirecter.component.scss']
})
export class AuthRegisterredirecterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    location.href = "/register";
  }

}
